import { createApp } from "vue";
import ProductStoreSelector from "../components/product-store-selector/ProductStoreSelector";

function productStoreSelectorApp() {
  const $parent = document.getElementById("productStoreSelectorApp");
  
  if (!$parent) {return;}

  const app = createApp(ProductStoreSelector);

  app.config.globalProperties.$config = {
    joineryHost: SDG.Data.joineryHost || "https://staging.framebridge.com"
  };

  app.mount("#productStoreSelectorApp");
}

export default productStoreSelectorApp;

